import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

export function RevokeApiKeyDialog({
  open,
  onOpenChange,
  keyName,
  onConfirm,
  loading,
  action = "revoke",
}) {
  const isDelete = action === "delete";
  const title = isDelete ? "Delete API Key" : "Revoke API Key";
  const description = isDelete
    ? `Are you sure you want to permanently delete the API key "${keyName}"? This cannot be undone.`
    : `Are you sure you want to revoke the API key "${keyName}"? Any integrations using this key will immediately stop working.`;
  const buttonLabel = isDelete ? "Delete" : "Revoke";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} disabled={loading}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                {buttonLabel === "Delete" ? "Deleting..." : "Revoking..."}
              </>
            ) : (
              buttonLabel
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
